module.exports = __webpack_public_path__ + "assets/img/title-8ea2639c.png";